import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(648); // 10:48
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 w-full bg-[#DC2626] text-white z-50 py-2.5 px-4 shadow-lg" data-id="element-14">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-medium" data-id="element-15">
        <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-16" />
        <span data-id="element-17">🔥 Esta oferta termina pronto — </span>
        <span className="font-bold font-mono bg-red-800 px-3 py-1 rounded text-lg" data-id="element-18">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
        <span className="hidden md:inline" data-id="element-19">— ¡No te quedes sin tu guía!</span>
      </div>
    </div>;
}